if (!customElements.get('vt-banner-carousel')) {
  class VtBannerCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-track]');
    this.slides = [...this.querySelectorAll('[data-slide]')];
    this.dots = [...this.querySelectorAll('[data-dot]')];
    this.autoplayEnabled = this.dataset.autoplay === 'true';
    this.speed = (parseInt(this.dataset.speed, 10) || 5) * 1000;
    this.current = 0;
    this.timer = null;

    if (!this.track || !this.slides.length) return;

    this.onScroll = () => this.syncDots();
    this.track.addEventListener('scroll', this.onScroll, { passive: true });

    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const index = parseInt(dot.dataset.dot, 10);
        if (!Number.isNaN(index)) this.goTo(index);
      });
    });

    this.onMouseEnter = () => this.stopAutoplay();
    this.onMouseLeave = () => this.startAutoplay();
    this.onFocusIn = () => this.stopAutoplay();
    this.onFocusOut = (event) => {
      if (!this.contains(event.relatedTarget)) this.startAutoplay();
    };

    this.addEventListener('mouseenter', this.onMouseEnter);
    this.addEventListener('mouseleave', this.onMouseLeave);
    this.addEventListener('focusin', this.onFocusIn);
    this.addEventListener('focusout', this.onFocusOut);

    this.syncDots();
    this.startAutoplay();
  }

  disconnectedCallback() {
    this.stopAutoplay();
    this.track?.removeEventListener('scroll', this.onScroll);
    this.removeEventListener('mouseenter', this.onMouseEnter);
    this.removeEventListener('mouseleave', this.onMouseLeave);
    this.removeEventListener('focusin', this.onFocusIn);
    this.removeEventListener('focusout', this.onFocusOut);
  }

  goTo(index) {
    const slide = this.slides[index];
    if (!slide || !this.track) return;

    this.current = index;
    this.track.scrollTo({
      left: slide.offsetLeft,
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
    });
    this.syncDots();
  }

  syncDots() {
    if (!this.track || !this.slides.length) return;

    const width = this.track.clientWidth || 1;
    const index = Math.max(0, Math.min(this.slides.length - 1, Math.round(this.track.scrollLeft / width)));
    this.current = index;

    this.dots.forEach((dot, dotIndex) => {
      const isActive = dotIndex === index;
      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
  }

  startAutoplay() {
    this.stopAutoplay();

    if (!this.autoplayEnabled || this.slides.length <= 1) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    this.timer = window.setInterval(() => {
      const next = (this.current + 1) % this.slides.length;
      this.goTo(next);
    }, this.speed);
  }

  stopAutoplay() {
    if (this.timer) {
      window.clearInterval(this.timer);
      this.timer = null;
    }
  }
  }

  customElements.define('vt-banner-carousel', VtBannerCarousel);
}
